import { ScrollTop } from "@/components/commons/ScrollTop";
import { Box } from "@mui/material";
import { FC } from "react";
import { Outlet } from "react-router-dom";

export const LoginLayout: FC = () => {
  return (
    <Box width="100%" minHeight={"100vh"} display="flex" justifyContent="center" pt={13} pb={3}>
      <ScrollTop />
      <Outlet />
    </Box>
  );
};
